import React, { useState } from "react";
import ImportIcon from "../../../assets/icons/import-01.svg2";
import { Col, Row, Spinner } from "react-bootstrap";

export default function DataImportMinimised() {
  return (
    <div>
      <div className="bg-dark opacity-75 align-items-end rounded-3 m-5 w-50 ">
        <div className="d-flex justify-content-end m-3 pb-3 pt-5">
          <div className="btn btn-colored-reverse  fw-bold px-4 border-0 ">
            <Row className="align-items-center">
              <Col xs={2}>
                <ImportIcon width={20} className="text-white mt-2 " />
              </Col>
              <Col xs={8}>
                <div className="text-nowrap">
                  <div className="text-start">Data Import Progress</div>
                  <div className="d-flex ">
                    <div className="fw-bold text-secondary text-nowrap">
                      Estimated Time:
                    </div>
                    <div className="text-secondary">1:25 minutes left</div>
                  </div>
                </div>
              </Col>
              <Col xs={2}>
                <Spinner
                  animation="border"
                  role="status"
                  className="mt-2  text-white "
                >
                  <span className="visually-hidden">Loading...</span>
                </Spinner>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </div>
  );
}
